// import {Form, useGetOne, useUpdate} from 'ra-core';
import TextInput from '@/components/refinedev/TextInput';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Section from '@/components/surface/Section';
import EditForm from '@/components/refinedev/pages/edit-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
import useAppSettingStore from '@/store/useAppSettingStore';

const schema = yup
  .object()
  .shape({
    site_name: yup.string().required('Cần đặt tên'),
  })
  .required();

const resolver = yupResolver(schema);

const AppSettings = () => {
  const {loaded, setLoaded} = useAppSettingStore();
  return (
    <EditForm
      submitDirtyFieldsOnly={false}
      formProps={{
        refineCoreProps: {
          resource: 'settings',
          id: 'general',
          onMutationSuccess: data => {
            console.log('onMutationSuccess', data);
            setLoaded(false); //force reload
          },
        },
        resolver,
      }}>
      <div className="flex flex-col items-start mt-4 space-y-4 w-2/3 mx-auto">        
        <Section className="w-full" title="Thiết lập chung" subtitle="Thiết lập chung về trang">
          <TextInput source="site_name" label="Tên trang" />
        </Section>
        <SaveButton size={'lg'}/>
      </div>
    </EditForm>
  );
};

export default AppSettings;
